function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Input, Form, Button, Select, Alert, Radio, List, Upload, Modal, Typography, Descriptions, message, DatePicker } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import axios from 'axios';
import Common from "../includes/Common";
import { ExclamationCircleFill, Upload as UploadIc } from 'react-bootstrap-icons';
import Receipt from "../Receipt";
import Moment from 'react-moment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var Option = Select.Option;

var NewCustomer = function NewCustomer(_ref) {
  var _ref$handleUpdate = _ref.handleUpdate,
      handleUpdate = _ref$handleUpdate === void 0 ? null : _ref$handleUpdate;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormLoading = _useState2[0],
      setIsFormLoading = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      successMessage = _useState6[0],
      setSuccessMessage = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      createdValues = _useState8[0],
      setCreatedValues = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      companyOptions = _useState10[0],
      setCompanyOptions = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      companies = _useState12[0],
      setCompanies = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      deptOptions = _useState14[0],
      setDeptOptions = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      serviceOptions = _useState16[0],
      setServiceOptions = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      deptDisabled = _useState18[0],
      setDeptDisabled = _useState18[1];

  var _useState19 = useState(true),
      _useState20 = _slicedToArray(_useState19, 2),
      companyDisabled = _useState20[0],
      setCompanyDisabled = _useState20[1];

  var _useState21 = useState(true),
      _useState22 = _slicedToArray(_useState21, 2),
      serviceDisabled = _useState22[0],
      setServiceDisabled = _useState22[1];

  var _useState23 = useState([]),
      _useState24 = _slicedToArray(_useState23, 2),
      serviceTree = _useState24[0],
      setServiceTree = _useState24[1];

  var _useState25 = useState(true),
      _useState26 = _slicedToArray(_useState25, 2),
      insDisabled = _useState26[0],
      setInsDisabled = _useState26[1]; //const [isPdaActive, setIsPdaActive] = useState(false);


  var _useState27 = useState(0),
      _useState28 = _slicedToArray(_useState27, 2),
      receipAmount = _useState28[0],
      setReceipAmount = _useState28[1];

  var _useState29 = useState(null),
      _useState30 = _slicedToArray(_useState29, 2),
      userCompany = _useState30[0],
      setUserCompany = _useState30[1];

  var _useState31 = useState([]),
      _useState32 = _slicedToArray(_useState31, 2),
      file = _useState32[0],
      setFile = _useState32[1];

  var _useState33 = useState(true),
      _useState34 = _slicedToArray(_useState33, 2),
      uploadDisabled = _useState34[0],
      setUploadDisabled = _useState34[1];

  var _useState35 = useState([]),
      _useState36 = _slicedToArray(_useState35, 2),
      rdata = _useState36[0],
      setRdata = _useState36[1];

  var _useState37 = useState(null),
      _useState38 = _slicedToArray(_useState37, 2),
      currentCompany = _useState38[0],
      setCurrentCompany = _useState38[1];

  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  var genderOptions = [{
    label: 'Homme',
    value: 'H'
  }, {
    label: 'Femme',
    value: 'F'
  }];
  var categoryOptions = [{
    label: 'Particulier',
    value: 0
  }, {
    label: 'Conventionné',
    value: 1
  }];

  var onCategorieChanged = function onCategorieChanged(e) {
    if (e == 1) {
      form.setFieldsValue({
        insurance_company_id: companyOptions
      });
      setCompanyDisabled(false);
      setInsDisabled(false);
      setUploadDisabled(false);
    } else {
      setCompanyDisabled(true);
      setInsDisabled(true);
      setUploadDisabled(true);
    }
  };

  var onDeptChanged = function onDeptChanged(e) {
    setServiceOptions([]);
    var optArray = e.toString().split(",");
    optArray.forEach(function (o) {
      var ar = serviceTree.filter(function (services) {
        return services.id == o;
      });

      if (ar.length > 0) {
        ar.forEach(function (d) {
          if (d.medical_items.length > 0) {
            d.medical_items.forEach(function (e) {
              setServiceOptions(function (prev) {
                return [].concat(_toConsumableArray(prev), [{
                  label: e.label,
                  value: e.id
                }]);
              });
            });
            form.setFieldsValue({
              service_id: serviceOptions
            });
            setServiceDisabled(false);
          }
        });
      }
    });
  };

  var onCompanyChanged = function onCompanyChanged(v) {
    setUserCompany(companies.filter(function (c) {
      return c.id == v;
    })[0]);
  };

  function printR() {
    var content = document.getElementById("prtdiv");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }

  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    }
  };

  var execOrder = function execOrder(formData) {
    setIsFormLoading(true);
    axios.post(Common.baseApiUrl + 'addcustomer/' + Common.currentUser.id.toString(), formData).then(function (response) {
      setIsFormLoading(false);

      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        setCreatedValues(response.data.customer);
        handleUpdate();
        printR();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormLoading(false);
      setErrorMessage('Une erreur est survenue');
    });
  };

  var onFinish = function onFinish(values) {
    setRdata([]);
    var formData = new FormData();
    formData.append('firstname', values.firstname);
    formData.append('lastname', values.lastname);
    formData.append('job', values.job);
    formData.append('birthdate', values.birthdate);
    formData.append('category', values.category);
    formData.append('mobile', values.mobile);
    formData.append('insnumber', values.insnumber);
    formData.append('company_id', values.company_id);
    formData.append("address", values.address);
    formData.append('gender', values.gender);
    formData.append('department_id', values.department_id);
    formData.append('item_id', values.item_id);
    formData.append('file', file);
    var ta = 0;
    values.item_id.toString().split(",").forEach(function (o) {
      serviceTree.forEach(function (d) {
        d.medical_items.forEach(function (e) {
          if (e.id == o) {
            //IF CASH PATIENT THE USE BASE PRICE
            if (values.category == 0) {
              ta += eval(e.base_price);
              ;
              setRdata(function (prev) {
                return [].concat(_toConsumableArray(prev), [e.label + " - " + e.base_price.toLocaleString('fr') + " GNF"]);
              });
            } else {
              //HANDLING COMPANY PRICE CATEGORIES
              var comp = companies.filter(function (c) {
                return c.id == values.company_id;
              })[0];

              if (comp.company_id == null) {
                ta += eval(e.ent_price);
                ;
                setRdata(function (prev) {
                  return [].concat(_toConsumableArray(prev), [e.label + " - " + e.ent_price.toLocaleString('fr') + " GNF"]);
                });
              }

              if (comp.company_id != null && comp.company.type == 1) {
                ta += eval(e.ins_price);
                ;
                setRdata(function (prev) {
                  return [].concat(_toConsumableArray(prev), [e.label + " - " + e.ins_price.toLocaleString('fr') + " GNF"]);
                });
              }

              if (comp.company_id != null && comp.company.type == 2) {
                ta += eval(e.lan_price);
                ;
                setRdata(function (prev) {
                  return [].concat(_toConsumableArray(prev), [e.label + " - " + e.lan_price.toLocaleString('fr') + " GNF"]);
                });
              }
            }
          }
        });
      });
    });
    formData.append('amount', ta);

    if (values.category == 1) {
      if (companies.filter(function (c) {
        return c.id == values.company_id;
      }).length > 0) {
        var company_rate = companies.filter(function (c) {
          return c.id == values.company_id;
        })[0].rate;
        setCurrentCompany(companies.filter(function (c) {
          return c.id == values.company_id;
        })[0]);
        formData.append('company_part', ta * company_rate * 0.01);
        formData.append('patient_part', ta * (100 - company_rate) * 0.01);
        setReceipAmount(ta * (100 - company_rate) * 0.01);
      }
    } else {
      formData.append("patient_part", ta);
      formData.append("company_part", 0);
      setReceipAmount(ta);
    }

    setErrorMessage('');
    setSuccessMessage('');
    confirm({
      title: 'Confirmez-vous ?',
      icon: /*#__PURE__*/_jsx(ExclamationCircleFill, {}),
      content: /*#__PURE__*/_jsx(Receipt, {
        company: userCompany,
        options: values.item_id,
        serviceTree: serviceTree
      }),
      onOk: function onOk() {
        execOrder(formData);
      },
      onCancel: function onCancel() {
        console.log('Cancel');
      }
    });
  };

  useEffect(function () {
    var cr = axios.get(Common.baseApiUrl + "getcompanylist");
    var st = axios.get(Common.baseApiUrl + "getservicetree");
    axios.all([cr, st]).then(function (response) {
      var crResponse = response[0];
      var stResponse = response[1];

      if (crResponse.data.status == 200) {
        setCompanies(crResponse.data.companyList);
        crResponse.data.companyList.forEach(function (c) {
          if (c.company_id == null) setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.label,
              value: c.id
            }]);
          });else setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.company == null ? "" : c.company.label + "-" + c.label,
              value: c.id
            }]);
          });
        });
        form.setFieldsValue({
          insurance_company_id: companyOptions
        });
      }

      if (stResponse.data.status == 200) {
        setServiceTree(stResponse.data.services);

        if (Common.currentUser.role == 11 || Common.currentUser.role == 81 || Common.currentUser.role == 101) {
          stResponse.data.services.forEach(function (d) {
            if (d.dcode != 'LUN' && d.dcode != 'PHA' && d.dcode != "CHI" && d.dcode != "LAS") setDeptOptions(function (prev) {
              return [].concat(_toConsumableArray(prev), [{
                value: d.id,
                label: d.label
              }]);
            });
          });
        }

        if (Common.currentUser.role == 71) {
          stResponse.data.services.forEach(function (d) {
            if (d.dcode == 'LAS' && d.dcode == 'CHI') setDeptOptions(function (prev) {
              return [].concat(_toConsumableArray(prev), [{
                value: d.id,
                label: d.label
              }]);
            });
          });
        }

        form.setFieldsValue({
          department: deptOptions
        });
        form.setFieldsValue({
          gender: 'F',
          category: 0,
          insnumber: null
        });
      }
    })["catch"](function (error) {});
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: errorMessage,
      type: "error",
      showIcon: true
    }), successMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: successMessage,
      type: "success",
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), createdValues != null && /*#__PURE__*/_jsxs("div", {
      style: {
        textAlign: 'center'
      },
      id: "prtdiv",
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: '70px',
          textAlign: 'center !important'
        },
        children: /*#__PURE__*/_jsx("img", {
          src: "drawables/logo_sos.jpeg",
          style: {
            width: '100%'
          }
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx("b", {
          children: "Date:"
        }), " ", /*#__PURE__*/_jsx(Moment, {
          format: "DD/MM/YYYY H:m"
        })]
      }), /*#__PURE__*/_jsxs("h2", {
        children: ["CODE PATIENT : ", createdValues.idnumber]
      }), /*#__PURE__*/_jsxs("h5", {
        children: ["Nom : ", createdValues.firstname + " " + createdValues.lastname]
      }), /*#__PURE__*/_jsx(List, {
        header: /*#__PURE__*/_jsx("div", {
          children: "Actes / Produit(s)"
        }),
        footer: /*#__PURE__*/_jsx("b", {
          children: "TOTAL (GNF) " + receipAmount.toLocaleString('fr')
        }),
        bordered: true,
        dataSource: rdata,
        renderItem: function renderItem(item) {
          return /*#__PURE__*/_jsx(List.Item, {
            children: /*#__PURE__*/_jsx(Typography.Text, {
              mark: true,
              children: item
            })
          });
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), currentCompany != null && /*#__PURE__*/_jsx(Alert, {
        type: "warning",
        banner: true,
        message: "Prise en charge de " + currentCompany.rate.toString() + "% par " + currentCompany.label
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("b", {
          children: "Adresse: Conakry, Kaloum, Manquepas - Tel: 622 32 59 32"
        })
      })]
    }), /*#__PURE__*/_jsx("iframe", {
      id: "ifmcontentstoprint",
      style: {
        height: '0px',
        width: '0px',
        position: 'absolute'
      }
    }), /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      onFinish: onFinish,
      form: form,
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "firstname",
            label: "Pr\xE9nom",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "lastname",
            label: "Nom",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "job",
            label: "Profession",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "mobile",
            label: "T\xE9l\xE9phone",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "birthdate",
            label: "Date de naissance",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(DatePicker, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "gender",
            label: "Genre",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Radio.Group, {
              options: genderOptions,
              optionType: "button",
              buttonStyle: "solid"
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "category",
            label: "Cat\xE9gorie",
            rules: [{
              required: true,
              message: 'Choisir la catégorie'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              showSearch: true,
              defaultActiveFirstOption: true,
              onChange: onCategorieChanged,
              optionLabelProp: "label",
              optionFilterProp: "label",
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              options: categoryOptions
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "company_id",
            label: "Prise en charge",
            children: /*#__PURE__*/_jsx(Select, {
              onChange: onCompanyChanged,
              disabled: companyDisabled,
              defaultActiveFirstOption: true,
              optionLabelProp: "label",
              optionFilterProp: "label",
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              showSearch: true,
              options: companyOptions
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "insnumber",
            label: "N\xBAprise en charge/ID assur\xE9",
            children: /*#__PURE__*/_jsx(Input, {
              disabled: insDisabled
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: " ",
            children: /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
              children: /*#__PURE__*/_jsx(Button, {
                disabled: uploadDisabled,
                icon: /*#__PURE__*/_jsx(UploadIc, {
                  size: 20
                }),
                children: /*#__PURE__*/_jsx("b", {
                  children: "Charger le bon"
                })
              })
            }))
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Adresse",
        name: "address",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "department_id",
            label: "Motif",
            rules: [{
              required: true,
              message: 'Choisir le motif'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              onChange: onDeptChanged,
              defaultActiveFirstOption: true,
              disabled: deptDisabled,
              showSearch: true,
              optionLabelProp: "label",
              optionFilterProp: "label",
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              options: deptOptions
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "item_id",
            label: "Actes / examens",
            rules: [{
              required: true,
              message: 'Choisir le motif'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              mode: "multiple",
              defaultActiveFirstOption: true,
              disabled: serviceDisabled,
              showSearch: true,
              optionLabelProp: "label",
              optionFilterProp: "label",
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              options: serviceOptions
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "submit",
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormLoading,
          htmlType: "submit",
          type: "default",
          children: "Enregistrer"
        })
      })]
    })]
  });
};

export default NewCustomer;